<h6>
    <span *ngIf="caseId > 0 && !referralsOnly">
        <span class="text-uppercase montserrat collapsible-text"
            (click)="otherCasesCollapsible.toggleChange()">{{'OTHER-CASES'
            | translate}}
        </span>
        <app-collapsible #otherCasesCollapsible [storageKey]="'case-other-cases'" [defaultCollapsed]="true"
            (collapsibleToggle)="caseOtherCasesCollapsed=$event">
        </app-collapsible>
    </span>
    <span *ngIf="referralsOnly">
        <span class="text-uppercase montserrat collapsible-text"
            (click)="referralsCollapsible.toggleChange()">{{'REFERRALS' | translate}}
        </span>
        <app-collapsible #referralsCollapsible [storageKey]="'case-referrals'" [defaultCollapsed]="true"
            (collapsibleToggle)="caseReferralsCollapsing($event)">
        </app-collapsible>
    </span>
    <kendo-dropdownlist
        *ngIf="(!referralsOnly && !caseOtherCasesCollapsed) || (referralsOnly && !caseReferralsCollapsed) || (caseId === 0 && referralsOnly && !caseReferralsCollapsed)"
        class="float-right k-dropdown"
        [attr.aria-label]="referralsOnly ? ('REFERRALS' | translate) : ('OTHER-CASES' | translate)"
        [ngClass]="{'mr-4': (caseId > 0 || (caseId === 0 && referralsOnly)), 'mr-1': caseId === 0 && !referralsOnly}"
        style="width:140px" [data]="caseFilters" [textField]="'text'" [valueField]="'value'"
        value="{{selectedCaseFilter}}" [valuePrimitive]="true" (valueChange)="caseFilterSelected($event)">
    </kendo-dropdownlist>
</h6>
<div *ngIf="(!referralsOnly && !caseOtherCasesCollapsed) || (referralsOnly && !caseReferralsCollapsed) || (caseId === 0 && referralsOnly && !caseReferralsCollapsed)"
    [ngStyle]="{'padding-top': caseId > 0 || referralsOnly ? '20px' : '40px'}">
    <kendo-grid #grid [data]="caseGridView" [navigable]="true"
        [pageable]="totalCases > caseState.take ? { buttonCount: 5, pageSizes: pageSizes } : false"
        [pageSize]="caseState.take" [skip]="caseState.skip" [loading]="otherCasesloading" [sort]="caseState.sort"
        [sortable]="true" [filterable]="false" [resizable]="true" (dataStateChange)="caseDataStateChange($event)"
        [selectable]="{ mode: 'single' }" [kendoGridSelectBy]="" class="mt-2 w-100">
        <kendo-grid-messages noRecords="{{ (referralsOnly ? 'NO-REFERRALS' : 'NO-CASES') | translate }}">
        </kendo-grid-messages>
        <kendo-grid-column *ngIf="!ehrContext" field="id" title="{{ 'CASE-ID-NUMBER' | translate }}" [width]="35"
            filter="numeric" format="#">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngxPermissionsOnly="['ROLE_OPERATOR']">
                    <a [routerLink]="['/case', dataItem.id]" class="emphasizedLabel font-weight-bold pointer">
                        {{dataItem.id}}
                    </a>
                </div>
                <div *ngxPermissionsOnly="['ROLE_CARE_COORDINATOR', 'ROLE_PROGRAM_LEAD']">
                    <div [ngSwitch]="isChannelAccessAllowed(dataItem)">
                        <div *ngSwitchCase="true">
                            <a [routerLink]="['/case', dataItem.id]" class="emphasizedLabel font-weight-bold pointer">
                                {{dataItem.id}}
                            </a>
                        </div>
                        <div *ngSwitchCase="false">
                            <span>{{dataItem.id}}</span>
                        </div>
                    </div>
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="!referralsOnly" field="channel" title="{{ 'CHANNEL' | translate }}" [width]="85">
        </kendo-grid-column>
        <kendo-grid-column *ngIf="referralsOnly" field="eventReferral.serviceCategory"
            title="{{ 'COMMUNITY-SERVICE-CATEGORY' | translate }}" [width]="40">
        </kendo-grid-column>
        <!--New Referrals combined columns-->
        <kendo-grid-column *ngIf="referralsOnly" field="eventReferral.referredServiceName"
            title="{{ 'REFERRED-ORGANIZATION' | translate }}" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.eventReferral.referredServiceName}}&nbsp;{{'AT' | translate | lowercase}}&nbsp;<span
                    class="at-text">{{dataItem.eventReferral.referredToOrganizationName}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="referralsOnly" field="eventReferral.referredFromName"
            title="{{ 'COMMUNITY-REFERRED-BY' | translate }}" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.eventReferral.referredFromName}}&nbsp;{{'AT' | translate | lowercase}}&nbsp;<span
                    class="at-text">{{dataItem.eventReferral.referredFromOrganizationName}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="referralsOnly" field="eventReferral.referredDate"
            title="{{ 'DATE-REFERRED' | translate }}" [width]="60" filter="date" format="{0:d}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem.eventReferral.referredDate !== null">
                    {{ intl.formatDate(intl.parseDate(dataItem.eventReferral.referredDate), 'g') }}
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="!referralsOnly" field="openedOn" title="{{ 'OPENED-ON' | translate }}" [width]="60"
            filter="date" format="{0:d}">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem.openedOn!==null">
                    {{ intl.formatDate(intl.parseDate(dataItem.openedOn), 'g') }}
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="referralsOnly" field="history.lastActivityOn"
            title="{{ 'LAST-ACTIVITY' | translate }}" [width]="40" filter="date">
            <!--Disable eq and neq operators which make no sense for date only picker on datetime field-->
            <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
                    <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
                    <kendo-filter-after-operator></kendo-filter-after-operator>
                    <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
                    <kendo-filter-before-operator></kendo-filter-before-operator>
                </kendo-grid-date-filter-cell>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <div *ngIf="dataItem.history !== null && dataItem.history.lastActivityOn !== null">
                    {{ intl.formatDate(intl.parseDate(dataItem.history.lastActivityOn), 'g') }}</div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="referralsOnly && channelWorkflowStatus !== null"
            field="channelWorkflowStatus.displayName" title="{{ 'CHANNEL-WORKFLOW-STATUS' | translate }}" [width]="40">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div
                    *ngIf="dataItem.channelWorkflowStatus && dataItem.channelWorkflowStatus && dataItem.channelWorkflowStatus.displayName">
                    {{dataItem.channelWorkflowStatus.displayName}}
                </div>
                <div *ngIf="dataItem.status === 'Open' && dataItem.eventReferral.referredProgramId !== null">
                    <a class="emphasizedLabel font-weight-bold pointer" style="text-decoration: underline;"
                        (click)="reassignReferral(dataItem)">{{'REASSIGN' | translate}}
                    </a>
                </div>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column *ngIf="!ehrContext" field="manager" title="{{ 'ASSIGNED-TO' | translate }}" [width]="50">
        </kendo-grid-column>
        <kendo-grid-column field="status" title="{{ 'STATUS' | translate }}" [width]="30"></kendo-grid-column>
        <ng-template *ngIf="loadedOtherCases" kendoGridDetailTemplate let-dataItem
            [kendoGridDetailTemplateShowIf]="showDetailsOnlyIfCaseAccessible">
            <app-case-detail-summary-task-grid [model]="dataItem" [refreshCaseOnUpdate]="true" [allowAddTask]="true">
            </app-case-detail-summary-task-grid>
        </ng-template>
    </kendo-grid>
</div>